import { render, staticRenderFns } from "./CustomAttributeDropDown.vue?vue&type=template&id=18a0f692&scoped=true&"
import script from "./CustomAttributeDropDown.vue?vue&type=script&lang=js&"
export * from "./CustomAttributeDropDown.vue?vue&type=script&lang=js&"
import style0 from "./CustomAttributeDropDown.vue?vue&type=style&index=0&id=18a0f692&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a0f692",
  null
  
)

export default component.exports